<template>
    <!-- <div style="margin: 0px; padding: 0px; width:100%">
        <div style="text-align: center;width:100%;margin-top: 50px; height: 100px;">因支付宝快捷登录升级，原支付宝快捷登录已作废</div>
        <div style="width:80%;text-align: center; background-color: coral; justify-items: center; display: flex;">

            <div style="width: 45%; height: 800px; ">

            </div>
        </div>
    </div> -->
    <div class="container">
        <!-- 顶部说明区域 -->
        <div class="header-section">
            <!-- <h1 class="header-title">智能系统管理平台</h1> -->
            <p class="header-description">
                因支付宝快捷登录升级，原支付宝快捷登录已作废。
            </p>
            <p class="header-description">
                老用户先用账号和密码登录二办平台后，在账户设置/基本信息下先绑定支付宝，之后就可以用支付宝扫码快捷登录；新用户或者已绑定的用户，直接支付宝快捷登录

            </p>
        </div>
        
        <!-- 主要内容区域 -->
        <div class="content-section fade-in">
            <!-- 左侧登录区域 -->
            <div class="left-panel">
                <h2 class="panel-title">还未绑定的老用户</h2>
                <p class="panel-subtitle">请输入您的账户信息进行登录</p>
                
                <div class="login-form" id="loginForm">
                    <div class="form-group">
                        <label class="form-label">账号</label>
                        <input type="text" 
                               class="form-input" 
                               id="username"
                               v-model="loginName"
                               placeholder="门牌号/手机号/邮箱"
                               required>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">密码</label>
                        <input type="password" 
                               class="form-input" 
                               id="password"
                               v-model="loginPwd"
                               placeholder="请输入密码"
                               required>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">验证码</label>
                        <div class="captcha-container">
                            <input type="text" 
                                   class="form-input captcha-input" 
                                   id="captcha"
                                   placeholder="请输入验证码"
                                   maxlength="4"
                                   v-model="loginCode"
                                   required>
                            <!-- <img src="https://via.placeholder.com/120x50/667eea/ffffff?text=1234" 
                                 alt="验证码" 
                                 class="captcha-image"
                                 id="captchaImage"
                                 title="点击刷新验证码"> -->
                                 <div class="code" @click="refreshCode">
                            <s-identify :identifyCode="identifyCode"></s-identify>
                        </div>
                        </div>
                    </div>
                    
                    <button v-on:click="login" class="login-button">
                        立即登录
                    </button>
                </div>
            </div>
            
            <!-- 分隔线 -->
            <div class="divider"></div>
            
            <!-- 右侧搜索区域 -->
            <div class="right-panel">
                <div class="search-container">
                    <h2 class="search-title">已绑定支付宝或者新用户</h2>
                    <p class="search-subtitle">使用支付宝快捷登录或者创建新用户</p>
                    
                    <div class="search-box">
                        <!-- <input type="text" 
                               class="search-input" 
                               id="searchInput"
                               placeholder="请输入搜索关键词..."
                               autocomplete="off"> -->
                        
                        <button class="search-button" id="searchButton" @click="alipayauth()">
                            支付宝快捷登录
                        </button>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import '../../assets/css/index.css'; /*引入公共样式*/
import crypto from 'crypto'
import {setCookie,getCookie} from  '../../assets/js/cookie.js'
var scrollingInterval;
export default {
    data(){
        return{
            msg:'',//密码输入错误请重新输入
            loginName:'',
            loginPwd:'',
            identifyCodes: "1234567890",
            identifyCode: "",
            loginCode: '',
            imgIndex:1,
        }
    },
    mounted() {
        
        this.makeCode(this.identifyCodes, 4);
    },
    destroyed:function(){
        clearInterval(scrollingInterval);
    },
    methods:{
        login(){
            // console.log('identifyCode',this.identifyCode);
            var that = this;
            if(this.loginName == ""){
                alert("请输入账号")
                return
            }
            if(this.loginPwd == ""){
                alert("请输入密码")
                return
            }
            if(this.loginCode != this.identifyCode){
                alert("验证码不正确")
                return
            }
            var password = this.$options.methods.getmd5(this.$options.methods.getmd5(this.loginPwd)+this.loginName)
            let data = {'loginName':this.loginName,'loginPwd':password,'loginSource':'web'}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/login/login.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                // console.log(JSON.stringify(res.data))
                if('0000000' == res.data.code)
                {
                    that.GLOBAL.token = res.data.token
                    setCookie('2officesessionid',res.data.token,60*60*10)
                    that.$router.push('/main')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getmd5(str){
            var a;
            var md5 = crypto.createHash("md5");
            md5.update(str);
            var a = md5.digest('hex');
            return a;
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        alipayauth(){
            location.href = "alipayauth"
        },
    }
}
</script>
<style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            
        }
        
        .container {
            width: 100%;
            /* max-width: 1200px; */
        }
        
        /* 顶部说明区域 */
        .header-section {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(10px);
            color: #333;
            padding: 40px;
            border-radius: 20px 20px 0 0;
            margin-bottom: 0;
            text-align: center;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            border-bottom: 3px solid #667eea;
        }
        
        .header-title {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 15px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
        }
        
        .header-description {
            font-size: 1.1rem;
            color: #666;
            max-width: 800px;
            margin: 0 auto;
            line-height: 1.8;
        }
        
        /* 主要内容区域 */
        .content-section {
            display: flex;
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(10px);
            border-radius: 0 0 20px 20px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            min-height: 550px;
        }
        
        /* 左侧登录区域 */
        .left-panel {
            flex: 1;
            padding: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        
        .panel-title {
            font-size: 1.8rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
        }
        
        .panel-subtitle {
            color: #666;
            margin-bottom: 30px;
            font-size: 0.95rem;
        }
        
        .login-form {
            width: 100%;
        }
        
        .form-group {
            margin-bottom: 25px;
            position: relative;
        }
        
        .form-label {
            display: block;
            margin-bottom: 8px;
            color: #555;
            font-weight: 500;
            font-size: 0.9rem;
        }
        
        .form-input {
            width: 100%;
            padding: 15px 20px;
            border: 2px solid #e1e5e9;
            border-radius: 10px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: #f8f9fa;
        }
        
        .form-input:focus {
            outline: none;
            border-color: #667eea;
            background: white;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
        
        .form-input:hover {
            border-color: #b5b9d0;
        }
        
        .captcha-container {
            display: flex;
            gap: 15px;
            align-items: center;
        }
        
        .captcha-input {
            flex: 1;
        }
        
        .captcha-image {
            height: 50px;
            border-radius: 8px;
            cursor: pointer;
            border: 2px solid #e1e5e9;
            transition: all 0.3s ease;
        }
        
        .captcha-image:hover {
            border-color: #667eea;
            transform: translateY(-2px);
        }
        
        .login-button {
            width: 100%;
            padding: 16px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border: none;
            border-radius: 10px;
            font-size: 1.1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            margin-top: 10px;
        }
        
        .login-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
        }
        
        .login-button:active {
            transform: translateY(0);
        }
        
        .login-options {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            font-size: 0.9rem;
        }
        
        .remember-me {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #666;
        }
        
        .remember-me input[type="checkbox"] {
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
        
        .forgot-password {
            color: #667eea;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.3s ease;
        }
        
        .forgot-password:hover {
            color: #764ba2;
            text-decoration: underline;
        }
        
        /* 分隔线 */
        .divider {
            width: 1px;
            background: linear-gradient(to bottom, 
                transparent 0%, 
                #ddd 10%, 
                #ddd 90%, 
                transparent 100%);
            position: relative;
            margin: 40px 0;
        }
        
        .divider::before {
            content: "或";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            color: #999;
            padding: 8px 16px;
            border-radius: 20px;
            font-size: 0.9rem;
            border: 1px solid #eee;
        }
        
        /* 右侧搜索区域 */
        .right-panel {
            flex: 1;
            padding: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;
        }
        
        .search-container {
            width: 100%;
        }
        
        .search-title {
            font-size: 1.8rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
        }
        
        .search-subtitle {
            color: #666;
            margin-bottom: 30px;
            font-size: 0.95rem;
        }
        
        .search-box {
            width: 100%;
            margin-bottom: 30px;
        }
        
        .search-input {
            width: 100%;
            padding: 15px 20px;
            border: 2px solid #e1e5e9;
            border-radius: 10px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: #f8f9fa;
            margin-bottom: 20px;
        }
        
        .search-input:focus {
            outline: none;
            border-color: #667eea;
            background: white;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
        
        .search-button {
            width: 100%;
            padding: 16px;
            background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%);
            color: white;
            border: none;
            border-radius: 10px;
            font-size: 1.1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
        }
        
        .search-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 20px rgba(76, 175, 80, 0.4);
        }
        
        .search-results {
            margin-top: 30px;
            max-height: 300px;
            overflow-y: auto;
        }
        
        .result-item {
            padding: 15px;
            background: #f8f9fa;
            border-radius: 8px;
            margin-bottom: 10px;
            border-left: 4px solid #4CAF50;
            transition: all 0.3s ease;
        }
        
        .result-item:hover {
            transform: translateX(5px);
            background: #e8f5e9;
        }
        
        .result-title {
            font-weight: 600;
            color: #333;
            margin-bottom: 5px;
        }
        
        .result-description {
            color: #666;
            font-size: 0.9rem;
        }
        
        /* 响应式设计 */
        @media (max-width: 768px) {
            .content-section {
                flex-direction: column;
            }
            
            .divider {
                width: 100%;
                height: 1px;
                margin: 0;
            }
            
            .divider::before {
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            
            .header-title {
                font-size: 2rem;
            }
            
            .left-panel, .right-panel {
                padding: 30px;
            }
        }
        
        /* 动画效果 */
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }
        
        .fade-in {
            animation: fadeIn 0.6s ease-out;
        }
        
        /* 滚动条样式 */
        .search-results::-webkit-scrollbar {
            width: 6px;
        }
        
        .search-results::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }
        
        .search-results::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
        }
        
        .search-results::-webkit-scrollbar-thumb:hover {
            background: #a1a1a1;
        }
    </style>


// WEBPACK FOOTER //
// src/components/alipaylogin/alipayinfo.vue